module.exports = __webpack_public_path__ + "img/the_hindu_logo.0339ba94.png";